import React from "react";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import speakers from "../data/speakersData";
import SpeakerCard from "../components/SpeakerCard";

const Speakers = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  const handleSpeakerClick = (id) => {
    navigate(`/speakers/${id}`); // Navigate to the speaker details page
  };

  return (
    <section className="bg-brandBlue flex font-outfit justify-center text-center px-4 pb-6 sm:px-6 md:px-10 lg:px-16 xl:px-20 flex-col">
      <h3 className="text-[1.3125rem] pt-[5rem] xxs:text-lg xs:text-lg xs:pt-[2rem] xxs:pt-[2rem] leading-[1.3125rem] mb-12 uppercase tracking-[0.2em] font-normal text-white">
        Meet Our Esteemed Speakers
      </h3>

      <div className="grid gap-x-6 gap-y-8 mix-blend-luminosity xs:gap-y-10 xxs:gap-y-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 justify-center justify-items-center">
        {speakers.map((speaker) => (
          <SpeakerCard
            key={speaker.id}
            speaker={speaker}
            onClick={() => handleSpeakerClick(speaker.id)} // Pass the onClick handler
          />
        ))}
      </div>
    </section>
  );
};

export default Speakers;
